import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, map, startWith, switchMap, tap } from 'rxjs/operators';
import { DeviceMapVO, DeviceMappingService } from 'src/app/services/device-mapping/device-mapping.service';

@Component({
  selector: 'app-search-device',
  templateUrl: './search-device.component.html',
  styleUrls: ['./search-device.component.scss'],
})
export class SearchDeviceComponent implements OnInit {
  @Output() deviceSelected = new EventEmitter<DeviceMapVO>();
  @Output() noSelectedOption = new EventEmitter<boolean>();
  @Input() searchInput: UntypedFormControl = new UntypedFormControl();
  @Input() manufacturer: string;
  @Input() searchModel: any = { appearance: 'legacy', showLabel: false };

  devicesUnmapped$: any;
  fallbackImageUrl = '/assets/no-image.png';
  constructor(private deviceUnmappedService: DeviceMappingService) {}

  ngOnInit(): void {
    this.getUnmappedDevices();
  }

  getUnmappedDevices(): void {
    this.devicesUnmapped$ = this.searchInput.valueChanges.pipe(
      startWith(''),
      filter((text) => !!text && text.length > 2),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((value: string) => this.deviceUnmappedService.getUnmappedDevicesByImei(value)),
      tap((devices) => console.log(devices)),
      map((devices) =>
        devices.map((deviceUnmapped) => ({ ...deviceUnmapped, device: { ...deviceUnmapped.device, imageUrl: deviceUnmapped.device.imageUrl ?? deviceUnmapped.device.imageURL } }))
      )
    );
  }

  emitSelectedDevice(device: DeviceMapVO) {
    this.deviceSelected.emit(device);
  }

  displayDevice(device: any): string {
    return device?.device?.imei ? device.device?.imei : '';
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.fallbackImageUrl;
  }
}
